import React from 'react';
import styles from './CMDashboard.module.css';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
const HomeLoan = '/images/icons/home_loan.svg';
import { numberFormat } from '../../common/constants/NumberFormat';
const {
  professional_data,
  professional_container,
  widthFit,
  cardsContainer,
  cmloandcard
} = styles;
import {
  ApplicantHeading,
  CardHeading
} from '../../components/CompanyDetailsCMView/CompanyDetailsCMView';

const LoanDetails = ({ each = [], index }) => {
  return (
    <div className=" w-full my-7">
      {index == 0 ? (
        <p className="font-roboto font-bold text-green-600 text-lg text-left ">
          Obligation Details
        </p>
      ) : null}
      <div className="w-full bg-white my-6 px-2 md:ml-8">
        {each.isMainApplicant ? (
          <ApplicantHeading heading="Main Applicant" />
        ) : (
          <ApplicantHeading heading={`Co-applicant ${index}`} />
        )}
        <div className={cardsContainer}>
          {each?.obligations.map((every, childIndex) => {
            return (
              <div className={cmloandcard}>
                <div className="w-full px-4   bg-white shadow-md  rounded-md border border-grey-1009 items-center">
                  <div className="w-full flex items-center mb-3">
                    <div className="flex">
                      <img src={HomeLoan} alt="loan type" />
                      <span className="text-black-600 font-roboto font-normal text-sm pl-3">
                        {every?.loanType || 'NA'}
                      </span>
                    </div>
                    <div className="ml-auto float-right block px-3 items-center pt-3">
                      <p className="text-green-paleGreen font-roboto font-bold text-lg">
                        {every?.sanctionAmount ? '₹ ' : null}
                        {numberFormat(every?.balanceAmount) || 'NA'}
                      </p>
                      <p className="text-black-1010 font-roboto font-normal text-sm">
                        Balance amount
                      </p>
                    </div>
                  </div>

                  <div
                    className={`lg:w-10/12 md:w-12/12 flex flex-wrap ${professional_container}`}
                  >
                    <div className={`block w-4/12  my-2 ${professional_data} `}>
                      <p className="text-grey-1003 font-roboto font-normal text-sm">
                        Sanction amount
                      </p>
                      <p className="text-black-400 font-roboto tet-base font-medium ">
                        {every?.sanctionAmount ? '₹ ' : null}
                        {numberFormat(every.sanctionAmount) || 'NA'}
                      </p>
                    </div>

                    <div className={`block w-4/12  my-2 ${professional_data} `}>
                      <p className="text-grey-1003 font-roboto font-normal text-sm">
                        Total Tenure in Months
                      </p>
                      <p className="text-black-400 font-roboto tet-base font-medium ">
                        {every?.totalTenure || 'NA'}
                      </p>
                    </div>

                    <div className={`block w-4/12  my-2 ${professional_data} `}>
                      <p className="text-grey-1003 font-roboto font-normal text-sm">
                        Balance Tenure in Months
                      </p>
                      <p className="text-black-400 font-roboto tet-base font-medium ">
                        {every?.balanceTenure || 'NA'}
                      </p>
                    </div>

                    <div className={`block w-4/12  my-2 ${professional_data} `}>
                      <p className="text-grey-1003 font-roboto font-normal text-sm">
                        Current EMI
                      </p>
                      <p className="text-black-400 font-roboto tet-base font-medium ">
                        {every?.currentEmi ? '₹ ' : null}
                        {numberFormat(every?.currentEmi) || 'NA'}
                      </p>
                    </div>

                    <div className={`block w-4/12  my-2 ${professional_data} `}>
                      <p className="text-grey-1003 font-roboto font-normal text-sm">
                        Lender Name
                      </p>
                      <p className="text-black-400 font-roboto tet-base font-medium ">
                        {every?.lender || 'NA'}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LoanDetails;
